import { useLocation, useNavigate } from "react-router-dom";
import { Card, Button, Table } from "antd";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  container: {
    padding: "20px",
    background: "#fff",
    minHeight: "100vh",
  },
  card: {
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
  },
  details: {
    marginBottom: "20px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
});

export default function OutletMultipleDeleteSuccess() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = location.state as any;

  const columns = [
    {
      title: "Kode",
      dataIndex: "code",
      key: "code",
      sorter: (a: any, b: any) => a.code.localeCompare(b.code),
    },
    {
      title: "Nama",
      dataIndex: "name",
      key: "name",
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
    },
  ];

  return (
    <div className={classes.container}>
      <Card className={classes.card}>
        <h2>Outlet Delete Success</h2>
        <Table
          columns={columns}
          dataSource={data}
          scroll={{ x: true }}
          pagination={{
            position: ["bottomRight"],
            pageSizeOptions: ["10", "50", "100"],
            showSizeChanger: true,
            defaultPageSize: 10,
          }}
        />
        <div className={classes.buttonContainer}>
          <Button onClick={() => navigate("/outlet")} type="default">
            Back
          </Button>
        </div>
      </Card>
    </div>
  );
}
